import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';

import { ApiErrorResponse, ApiResponse } from '@/types/api';
import { api } from '@/utils/api';

export interface CardType {
  id: number;
  name: string;
  number: string;
  billingKey: string;
  isValid: boolean;
}

export interface PlanType {
  id: number;
  type: 'yearly' | 'monthly';
  name: string;
  price: number;
  totalPrice: number;
  title: string;
}

export interface SubscriptionType {
  id: number;
  expiredAt: string | null;
  nextOrderAt: string;
  plan: PlanType;
  nextPlan: PlanType;
}

export interface GetSubScriptionAndCardInfoResponse {
  subscription: SubscriptionType | null;
  card: CardType | null;
}

export const getSubScriptionAndCardInfo = () => {
  return api.get<ApiResponse<GetSubScriptionAndCardInfoResponse>>('/pay');
};

const useSubscriptionAndCardInfo = <
  TData = AxiosResponse<ApiResponse<GetSubScriptionAndCardInfoResponse>>,
  TError = AxiosError<ApiErrorResponse>,
>(
  options?: UseQueryOptions<
    AxiosResponse<ApiResponse<GetSubScriptionAndCardInfoResponse>>,
    TError,
    TData,
    ['getSubscriptionAndCardInfo']
  >,
): UseQueryResult<TData, TError> => {
  return useQuery(
    ['getSubscriptionAndCardInfo'],
    () => getSubScriptionAndCardInfo(),
    { ...options },
  );
};

export default useSubscriptionAndCardInfo;
